/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductCategoryCreate
 */
export interface ProductCategoryCreate {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreate
     */
    description: string;
}

/**
 * Check if a given object implements the ProductCategoryCreate interface.
 */
// @ts-ignore
export function instanceOfProductCategoryCreate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

// @ts-ignore
export function ProductCategoryCreateFromJSON(json: any): ProductCategoryCreate {
    return ProductCategoryCreateFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductCategoryCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategoryCreate {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
    };
}

// @ts-ignore
export function ProductCategoryCreateToJSON(value?: ProductCategoryCreate | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

